<template>
  <div class="tabs">
    <el-tabs :type="type" v-if="!isHideNav" v-model="tabsValue" @tab-click="tabClick">
      <el-tab-pane v-for="item in data" :key="item.value" :label="item.text" :name="item.value"></el-tab-pane>
    </el-tabs>
    <div class="tabs-content">
      <div class="tabs-aside">
        <slot name="aside"></slot>
      </div>
      <div class="tabs-body">
        <div class="tabs-header">
          <slot name="card"></slot>
        </div>
        <div class="table">
          <slot></slot>
        </div>
        <div class="tabs-footer">
          <slot name="pagination"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  model: {
    prop: 'value',
    event: 'changeValue'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'border-card'
    },
    isHideNav: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabsValue: this.value
    }
  },
  methods: {
    tabClick(val) {
      this.$emit('changeValue', this.tabsValue)
      this.$emit('tab-click', val)
    }
  }
}
</script>

<style scoped lang="less">
.tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  border: 1px solid #DCDFE6;
  // box-shadow: 0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);
  ::v-deep .el-tabs {
    width: 100%;
    height: 32px;
    flex-shrink: 0;
    border: none;
    box-shadow: none;
    .el-tabs__header {
      flex-shrink: 0;
      .el-tabs__item,
      .el-tabs__nav-prev,
      .el-tabs__nav-next {
        height: 32px;
        line-height: 32px;
      }
    }
    .el-tabs__content {
      padding: 0;
    }
  }
  .tabs-content {
    height: 100%;
    display: flex;
    flex: 1;
    flex-basis: auto;
    overflow: auto;
    box-sizing: border-box;
    min-width: 0;
  }
  .tabs-body {
    display: flex;
    flex: 1;
    flex-basis: auto;
    overflow: auto;
    box-sizing: border-box;
    flex-direction: column;
    min-width: 0;
    padding: 12px 12px 0;
    ::v-deep .tabs-header {
      .el-card__body {
        padding: 12px 20px;
      }
    }
    .table {
      flex: 1;
      flex-basis: auto;
      overflow: auto;
      box-sizing: border-box;
    }
    .tabs-footer,
    .tabs-header {
      box-sizing: border-box;
      flex-shrink: 0;
    }
  }
}
</style>